<template>
<div class="chapter">
<div class="inner_page">
<p class="toc-title"><a id="pagev"></a>Contents</p>
<table width="100%">
<colgroup>
<col width="5%"/>
<col width="95%"/>
</colgroup>
<tbody>
<tr>
<td valign="top"> </td>
<td valign="top"><a href="#/05_acknowledgements#acknowledgements" id="racknowledgements">Acknowledgements</a></td>
</tr>
<tr class="spaceUper">
<td valign="top"> </td>
<td valign="top"><a href="#/06_introduction#introduction" id="rintroduction">Introduction</a></td>
</tr>
<tr class="spaceUper">
<td valign="top"><a href="#/07_chapter1#ch01">  1</a></td>
<td valign="top"><a href="#/07_chapter1#ch01" id="rch01">Overlord</a></td>
</tr>
<tr class="spaceUper">
<td valign="top"><a href="#/08_chapter2#ch02">  2</a></td>
<td valign="top"><a href="#/08_chapter2#ch02" id="rch02">Beachhead Assault</a></td>
</tr>
<tr class="spaceUper">
<td valign="top"><span href="#/09_chapter3#ch03" title="Link target outside of Sample">  3</span></td>
<td valign="top"><span href="#/09_chapter3#ch03" id="rch03" title="Link target outside of Sample">Attritional Battles in the Bridgehead – June</span></td>
</tr>
<tr class="spaceUper">
<td valign="top"><span href="#/10_chapter4#ch04" title="Link target outside of Sample">  4</span></td>
<td valign="top"><span href="#/10_chapter4#ch04" id="rch04" title="Link target outside of Sample">The War of Attrition Continues – July</span></td>
</tr>
<tr class="spaceUper">
<td valign="top"><span href="#/11_chapter5#ch05" title="Link target outside of Sample">  5</span></td>
<td valign="top"><span href="#/11_chapter5#ch05" id="rch05" title="Link target outside of Sample">August Break-out</span></td>
</tr>
<tr class="spaceUper">
<td valign="top"><span href="#/12_chapter6#ch06" title="Link target outside of Sample">  6</span></td>
<td valign="top"><span href="#/12_chapter6#ch06" id="rch06" title="Link target outside of Sample">Operation Neptune and the Great Swan</span></td>
</tr>
<tr class="spaceUper">
<td valign="top"><span href="#/13_chapter7#ch07" title="Link target outside of Sample">  7</span></td>
<td valign="top"><span href="#/13_chapter7#ch07" id="rch07" title="Link target outside of Sample">Operation Garden</span></td>
</tr>
<tr class="spaceUper">
<td valign="top"><span href="#/14_chapter8#ch08" title="Link target outside of Sample">  8</span></td>
<td valign="top"><span href="#/14_chapter8#ch08" id="rch08" title="Link target outside of Sample">Long Hard Winter – the Maas and Peel Country</span></td>
</tr>
<tr class="spaceUper">
<td valign="top"><span href="#/15_chapter9#ch09" title="Link target outside of Sample">  9</span></td>
<td valign="top"><span href="#/15_chapter9#ch09" id="rch09" title="Link target outside of Sample">The Ardennes</span></td>
</tr>
<tr class="spaceUper">
<td valign="top"><span href="#/16_chapter10#ch10" title="Link target outside of Sample">10</span></td>
<td valign="top"><span href="#/16_chapter10#ch10" id="rch10" title="Link target outside of Sample">Breaking the Siegfried Line: the Reichwald Battles</span></td>
</tr>
<tr class="spaceUper">
<td valign="top"><span href="#/17_chapter11#ch11" title="Link target outside of Sample">11</span></td>
<td valign="top"><span href="#/17_chapter11#ch11" id="rch11" title="Link target outside of Sample">From the Rhine to the Baltic: ‘Twilight of the Gods’</span></td>
</tr>
<tr class="spaceUper">
<td valign="top"> </td>
<td valign="top"><span href="#/18_envoi#envoi" id="renvoi" title="Link target outside of Sample">Envoi</span></td>
</tr>
<tr class="spaceUper">
<td valign="top"> </td>
<td valign="top"><span href="#/19_index#index" id="rindex" title="Link target outside of Sample">Index</span></td>
</tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_contents.vue?bf4c707c